import React, { useState } from 'react';
import { Control, Controller } from 'react-hook-form';
import type { PinInputRootProps } from '@chakra-ui/react';
import { Box, Field, PinInput } from '@chakra-ui/react';
import type { ValueChangeDetails as PinValueChangeDetails } from '@zag-js/pin-input';

type PinInputTypes = {
  invalid?: boolean;
  name: string;
  length: number;
  control: Control<any>;
} & Omit<PinInputRootProps, 'value' | 'onValueChange' | 'children'>;

const PinInputField: React.FC<PinInputTypes> = ({
  invalid,
  name,
  control,
  length,
  ...props
}) => {
  const [filled, setFilled] = useState<boolean>(false);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => {
        const str = typeof value === 'string' ? value : '';
        const pinValues = Array.from({ length }, (_, i) => str[i] ?? '');
        return (
          <Field.Root invalid={invalid}>
            <Box
              border="1px"
              borderColor={filled ? 'primary' : 'body2'}
              rounded="lg"
              background={filled ? 'rgba(241, 248, 242, 0.1)' : 'transparent'}
              pt={1}
              pb={0.5}
              _hover={{ background: 'rgba(241, 248, 242, 0.1)' }}
            >
              <PinInput.Root
                otp
                placeholder="_"
                value={pinValues}
                onValueChange={(d: PinValueChangeDetails) =>
                  onChange(d.valueAsString)
                }
                invalid={invalid}
                {...props}
              >
                <PinInput.Control>
                  {Array.from({ length: length }, (_, index) => (
                    <PinInput.Input
                      key={index}
                      {...({
                        onFocus: () => setFilled(true),
                        onBlur: () => setFilled(false),
                        onKeyDown: () => setFilled(false),
                        style: {
                          border: 'none',
                          background: 'transparent',
                          color: 'var(--chakra-colors-secondary2)',
                        },
                      } as any)}
                    />
                  ))}
                </PinInput.Control>
              </PinInput.Root>
            </Box>
          </Field.Root>
        );
      }}
    />
  );
};

PinInputField.displayName = 'PinInput';
export default PinInputField;
